import { Checkbox } from '@mui/material';
import { DataCellProps } from '../types';

export const TenantCheckboxCell = ({
  tenant: { id: tenantId },
  _customRowProps: { selectTenant, selectedTenantIds },
  hideSelectBox,
}: DataCellProps) => {
  if (hideSelectBox) {
    return <></>;
  }
  return (
    <div>
      <Checkbox
        checked={selectedTenantIds.has(tenantId)}
        onClick={() => selectTenant({ tenantId })}
      />
    </div>
  );
};
